var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 20,
    viewBox: "0 0 32 20",
    width: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 19.5,
    rx: 1.75,
    width: 31.5,
    x: 0.25,
    y: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 19.5,
    rx: 1.75,
    stroke: "black",
    strokeWidth: 0.5,
    width: 31.5,
    x: 0.25,
    y: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.0419 13.2079H9.32546L8.03833 8.15306C7.97724 7.92054 7.84752 7.71497 7.65671 7.61808C7.18052 7.37461 6.6558 7.18084 6.08337 7.08311V6.88849H8.84844C9.23005 6.88849 9.51627 7.18084 9.56397 7.52036L10.2318 11.1666L11.9474 6.88849H13.6161L11.0419 13.2079ZM14.5706 13.2079H12.9496L14.2844 6.88849H15.9054L14.5706 13.2079ZM18.002 8.63844C18.0497 8.29807 18.3359 8.10346 18.6698 8.10346C19.1945 8.0546 19.7661 8.15233 20.2431 8.39496L20.5293 7.03435C20.0523 6.83974 19.5276 6.74201 19.0514 6.74201C17.4781 6.74201 16.3332 7.61735 16.3332 8.83221C16.3332 9.75641 17.1441 10.2417 17.7166 10.534C18.3359 10.8255 18.5744 11.0201 18.5267 11.3116C18.5267 11.7489 18.0497 11.9435 17.5735 11.9435C17.001 11.9435 16.4286 11.7977 15.9047 11.5543L15.6185 12.9157C16.1909 13.1583 16.8102 13.2561 17.3827 13.2561C19.1468 13.3041 20.2431 12.4296 20.2431 11.117C20.2431 9.46407 18.002 9.36718 18.002 8.63844ZM25.9166 13.2079L24.6295 6.88849H23.2469C22.9607 6.88849 22.6745 7.08311 22.5791 7.37461L20.1957 13.2079H21.8644L22.1975 12.2846H24.2479L24.4387 13.2079H25.9166ZM23.4859 8.58967L23.9621 10.9714H22.6273L23.4859 8.58967Z",
    fill: "#172B85",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc5);
export default __webpack_public_path__ + "static/media/ic5.4080092a4f8d9fb1a62810e1ce1a45a2.svg";
export { ForwardRef as ReactComponent };